import { Component, Input, OnInit } from '@angular/core';

import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ChatService } from '../../services/chat.service';
import { MessageTimestampComponent } from '../common/message-timestamp/message-timestamp.component';

@Component({
  selector: 'app-user-message',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MessageTimestampComponent,
  ],
  templateUrl: './user-message.component.html',
  styleUrls: ['./user-message.component.scss'],
})
export class UserMessageComponent implements OnInit {
  @Input() input: any;

  config: any;
  messageText: string = '';
  files: any;
  type: string = 'NA';

  constructor(private chatService: ChatService) {}

  get configs() {
    return this.chatService.configs;
  }

  ngOnInit() {
    this.config = this.input?.config;
    this.messageText = this.input?.message_text;
    this.files = this.input?.files;
    this.type = this.input?.type;
  }
}
